import React, { useEffect, useState } from 'react';
import { adminGetTabInsights, adminGenerateTabInsights } from '../../lib/api';
import { Sparkles } from 'lucide-react';

export default function TabInsights({ tab }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setData(null);
    adminGetTabInsights(tab).then((r) => { if (r.insights) setData(r); }).catch(() => {});
  }, [tab]);

  const generate = async () => {
    setLoading(true);
    setError('');
    try { setData(await adminGenerateTabInsights(tab)); }
    catch (e) { setError(e?.response?.data?.detail || 'Claude could not analyse this tab right now.'); }
    finally { setLoading(false); }
  };

  return (
    <div className="alp-beam rounded-2xl p-[1.5px] mb-6" data-testid={`tab-insights-${tab}`}>
      <div className="rounded-[calc(1rem-1.5px)] bg-alp-black/95 backdrop-blur-2xl px-5 py-4">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div className="flex items-center gap-2">
            <Sparkles size={14} strokeWidth={1.5} className="text-alp-gold animate-pulse" />
            <span className="text-[10px] tracking-[0.3em] uppercase text-alp-gold">Luxe Intelligence</span>
            {data && <span className="text-[9px] tracking-[0.15em] uppercase px-2 py-0.5 rounded-full border border-alp-gold/40 text-alp-gold/90">Claude</span>}
          </div>
          <button onClick={generate} disabled={loading} data-testid={`tab-insights-btn-${tab}`}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[10px] tracking-[0.15em] uppercase border border-alp-gold/50 text-alp-gold hover:bg-alp-gold hover:text-alp-black transition-colors disabled:opacity-50">
            <Sparkles size={11} className={loading ? 'animate-spin' : ''} /> {loading ? 'Claude is thinking...' : data ? 'Refresh' : 'Ask Claude about this tab'}
          </button>
        </div>
        {error && <p className="text-red-400 text-xs mt-2">{error}</p>}
        {!data && !error && !loading && (
          <p className="text-alp-cream/40 text-xs mt-2">Claude will read this tab&apos;s live data and point out what matters.</p>
        )}
        {data && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-1.5 mt-3">
            {data.insights.map((t, i) => (
              <p key={i} className="text-alp-cream/85 text-[13px] leading-relaxed flex gap-2" data-testid={`tab-insight-${tab}-${i}`}>
                <span className="text-alp-gold shrink-0 mt-[1px]">&#9670;</span>{t}
              </p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
